import React from 'react';
import GradientButton from '../../../components/atoms/GradientButton';
import GradientOutlineButton from '../../../components/atoms/GradientOutlineButton';
import fromOne from '../../../assets/images/home_screen/form_one.webp';
import fromTwo from '../../../assets/images/home_screen/form_two.webp';
import { motion } from 'framer-motion';

// Ducuments imports local:
import intakeForm from '../../../assets/documents/new_patient_intake.pdf';
import pediatricPolicies from '../../../assets/documents/educational_services_policies.pdf';
import insuranceVerification from '../../../assets/documents/insurence_verification_form.pdf';
import cancellationPolicy from '../../../assets/documents/cancellation_financial_policy.pdf';
import privacyPractices from '../../../assets/documents/privacy_practices.pdf';
import telehealthConsent from '../../../assets/documents/telehealth_services.pdf';
import agreementService from '../../../assets/documents/Education - Agreement of Services_06062025.pdf';
import feeSchedule from '../../../assets/documents/Education Services Fee Schedule_06062025.pdf';
import { openPdf } from '../../../utils/hooks/utils';

const IntakeForm = () => {
  const forms = [
    {
      src: fromTwo,
      rotate: 'rotate-[-20deg] -top-14 -right-[70px] md:-right-[110px]',
    },
    {
      src: fromOne,
      rotate: 'rotate-[-10deg] top-[195px] -right-[0px] md:left-[70px]',
    },
  ];

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.75,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.5 } },
  };

  return (
    <div className="w-full flex flex-col lg:flex-row items-center justify-between max-w-[1238px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-30 gap-20">
      <div className="flex-1 w-full">
        <h4 className="text-xl lg:text-3xl 2xl:text-4xl text-primary font-bold mb-8 sm:mb-12">
          To make your appointment seamless and to reduce waiting time, please
          bring completed intake forms to your first appointment.
        </h4>
        <div className="mb-8 sm:mb-12">
          <h3 className="text-xl lg:text-[28px] text-[#555859] font-bold mb-3">
            Intake Forms
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-6">
            <GradientButton
              text="Intake General History"
              isDark={false}
              onClick={() => openPdf(intakeForm)}
            />
            <GradientButton
              text="Pediatric Policies"
              isDark={false}
              onClick={() => openPdf(pediatricPolicies)}
            />
            <GradientButton
              text="Insurance Verification"
              isDark={false}
              onClick={() => openPdf(insuranceVerification)}
            />
            <GradientButton
              text="Cancellation Financial Policy"
              isDark={false}
              onClick={() => openPdf(cancellationPolicy)}
            />
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-6 w-full">
          <div className="flex flex-col">
            <h3 className="text-xl lg:text-[28px] text-[#555859] font-bold mb-3">
              Telehealth
            </h3>
            <GradientButton
              text="Telehealth Consent"
              isDark={false}
              width="w-full"
              onClick={() => openPdf(telehealthConsent)}
            />
          </div>
          <div className="flex flex-col mb-8">
            <h3 className="text-xl lg:text-[28px] text-[#555859] font-bold mb-3">
              Other
            </h3>
            <GradientOutlineButton
              text="Privacy Practice"
              isDark={false}
              width="w-full"
              onClick={() => openPdf(privacyPractices)}
            />
          </div>
        </div>
        <div className="mb-8 sm:mb-12">
          <h3 className="text-xl lg:text-[28px] text-[#555859] font-bold mb-3">
            Educational Services
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-6 w-full">
            <GradientButton
              text="Agreement of Services"
              isDark={false}
              width="w-full"
              onClick={() => openPdf(agreementService)}
            />
            <GradientButton
              text="Educational Fee Schedule"
              isDark={false}
              width="w-full"
              onClick={() => openPdf(feeSchedule)}
            />
          </div>
        </div>
      </div>
      <div className="flex-1 w-full flex justify-center">
        <motion.div
          className="relative w-[240px] md:w-[320px] h-[450px] mt-8 mb-20"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {forms.map((form, index) => (
            <motion.div
              key={index}
              className={`absolute ${form.rotate} z-[${index}]`}
              variants={itemVariants}
            >
              <img
                src={form.src}
                alt={`Form ${index + 1}`}
                className="w-auto h-[320px]"
              />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default IntakeForm;
